module.exports = __webpack_public_path__ + "img/checkLogo.b8f10233.png";